import { render, staticRenderFns } from "./_fieldBase.vue?vue&type=template&id=287e9514"
import script from "./_fieldBase.js?vue&type=script&lang=js&external"
export * from "./_fieldBase.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports